const actions = {
  SET_STATE: 'thirdparty/SET_STATE',
  LOAD_ALL: 'thirdparty/LOAD_ALL',
  SYNC_DOMAIN: 'thirdparty/SYNC_DOMAIN',
}

export default actions
